import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createBlock as _createBlock, withKeys as _withKeys } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Bewerberfragen", -1)
const _hoisted_2 = { style: {"display":"flex","flex-direction":"column","justify-content":"space-between","height":"100%"} }
const _hoisted_3 = { style: {"display":"flex","justify-content":"flex-end"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_error_snackbar = _resolveComponent("error-snackbar")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_error_snackbar, {
      snackbar: _ctx.errorSnackbar,
      "onUpdate:snackbar": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.errorSnackbar) = $event))
    }, null, 8, ["snackbar"]),
    _createVNode(_component_v_container, { fluid: "" }, {
      default: _withCtx(() => [
        _hoisted_1,
        _createVNode(_component_v_divider),
        _createVNode(_component_v_row, { class: "mt-4" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documentTypes, (docType, index) => {
              return (_openBlock(), _createBlock(_component_v_col, {
                cols: "12",
                sm: "6",
                md: "4",
                key: index
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    onClick: ($event: any) => (_ctx.openApplicantQuestionEditor(docType.id))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                          _createVNode(_component_v_btn, {
                            class: "mr-2 mt-2",
                            density: "comfortable",
                            icon: "mdi-sort",
                            onClick: _withModifiers(($event: any) => (_ctx.openSortingDialog(docType.id)), ["stop"])
                          }, null, 8, ["onClick"])
                        ]),
                        _createVNode(_component_v_card_text, { class: "d-flex justify-center align-center mt-n4" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { size: "60" }, {
                              default: _withCtx(() => [
                                _createTextVNode("mdi-file-document")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_card_title, { class: "d-flex justify-center align-center" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(docType.name), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_v_dialog, {
          modelValue: _ctx.dialog,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dialog) = $event)),
          "max-width": "1000",
          persistent: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Edit Questions")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredQuestions, (element) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: element.id,
                        class: "d-flex mb-2 align-center"
                      }, [
                        _createVNode(_component_v_text_field, {
                          modelValue: element.question,
                          "onUpdate:modelValue": ($event: any) => ((element.question) = $event),
                          label: "Question",
                          dense: "",
                          "append-icon": "mdi-close",
                          "onClick:append": ($event: any) => (_ctx.openDeleteConfirmationDialog(element.id))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onClick:append"])
                      ]))
                    }), 128)),
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.newQuestion,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newQuestion) = $event)),
                      label: "New Question",
                      dense: "",
                      onKeydown: _withKeys(_withModifiers(_ctx.addQuestion, ["prevent"]), ["enter"])
                    }, null, 8, ["modelValue", "onKeydown"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      color: "danger",
                      text: "",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dialog = false))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Cancel")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      text: "",
                      onClick: _ctx.saveQuestions
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Änderungen speichern")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_v_dialog, {
          modelValue: _ctx.sortingDialog,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.sortingDialog) = $event)),
          "max-width": "1000",
          persistent: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Sort Questions")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_draggable, {
                      modelValue: _ctx.filteredQuestions,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filteredQuestions) = $event)),
                      list: _ctx.filteredQuestions,
                      tag: "transition-group",
                      animation: 150
                    }, {
                      item: _withCtx(({ element }) => [
                        (_openBlock(), _createElementBlock("div", {
                          key: element.id,
                          class: "d-flex mb-2 align-center"
                        }, [
                          _createVNode(_component_v_icon, {
                            class: "mt-1 mr-2",
                            style: {"cursor":"move"}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("mdi-drag")
                            ]),
                            _: 1
                          }),
                          _createElementVNode("span", null, _toDisplayString(element.question), 1)
                        ]))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "list"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      color: "danger",
                      text: "",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sortingDialog = false))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Cancel")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      text: "",
                      onClick: _ctx.saveQuestionsSort
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Save")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_v_dialog, {
          modelValue: _ctx.deleteConfirmationDialog,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.deleteConfirmationDialog) = $event)),
          "max-width": "400"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "headline" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Are you sure?")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createTextVNode(" Do you really want to delete this question? This action cannot be undone. ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      text: "",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.deleteConfirmationDialog = false))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Cancel")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      color: "danger",
                      text: "",
                      onClick: _cache[8] || (_cache[8] = () => { _ctx.deleteQuestion(_ctx.questionToDelete); _ctx.deleteConfirmationDialog = false; })
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Delete")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    })
  ], 64))
}